<template>
    <transition-page
        :title="trans('courses.esercizi.rescheduled_fine')"
        :description="trans('courses.esercizi.see_you_later')"
        imgPath="/images/icons-v4/mission_scheduled.svg"
        :ctaText="trans('courses.esercizi.go_to_dashboard')"
        :chapterName="chapterName"
        :chapterIcon="chapterIcon"
        @onCompleted="onCompleted"
    />
</template>
<script>
import TransitionPage from "../../molecules/TransitionPage"
import navMixin from "../../mixins/navMixin"

export default {
    name: "MissionScheduled",
    components: {TransitionPage},
    mixins: [navMixin],
    data: () => ({
        missionId: null,
        chapterName: '',
        chapterIcon: '',
    }),
    mounted() {
        this.programId = this.$route.params.programId
        this.moduleId = this.$route.params.moduleId
        this.missionId = this.$route.params.id
        this.getMissionData()
    },
    methods: {
        getMissionData() {
             this.$axios.get(`/api/rest/programs/${this.programId}/modules/${this.moduleId}/missions/${this.missionId}`)
                .then(res => {
                    this.chapterName = res.data.chapterName
                    this.chapterIcon = res.data.chapterIcon
                })
                .catch(err => console.error(err))
        },
        async onCompleted() {
            try {
                const res = await this.$axios.post(`/api/rest/programs/${this.programId}/modules/${this.moduleId}/missions/${this.missionId}/tracking/scheduled`)
                this.$router.push(this.parseMasterNav(res.data))
            }catch(err){
                console.log(err);
            }
        }
    }
}
</script>
